import { render, staticRenderFns } from "./scenicSpot.vue?vue&type=template&id=bad9a1e8&scoped=true&"
import script from "./scenicSpot.vue?vue&type=script&lang=js&"
export * from "./scenicSpot.vue?vue&type=script&lang=js&"
import style0 from "./scenicSpot.vue?vue&type=style&index=0&id=bad9a1e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad9a1e8",
  null
  
)

export default component.exports